import { bindGoldenGenerateFn } from '../golden/gemini.agents';
import type { GoldenGenerateParams, GoldenGenerateResponse } from '../golden/goldenTransport';
import type { OriginalEngineAITransport, OriginalEngineTransportContext } from '../types';
import { bindGoldenGenerateWithLogicalCalls } from './boundedCompatTransport';

export function createGoldenGenerateBinding(
  transport: OriginalEngineAITransport,
  baseContext: Pick<OriginalEngineTransportContext, 'projectId' | 'chapterNumber'>,
): void {
  bindGoldenGenerateWithLogicalCalls(
    transport,
    baseContext,
    (fn) => bindGoldenGenerateFn(fn),
    inferAgentFromParams,
  );
}

function inferAgentFromParams(params: GoldenGenerateParams): OriginalEngineTransportContext['agent'] {
  const instruction = String(params.config?.systemInstruction || '');
  if (instruction.includes('PUBLICATION EDITOR') || instruction.includes('PUBLICATION_EDITOR')) {
    return 'PUBLICATION_EDITOR';
  }
  if (instruction.includes('THE INSPECTOR') || instruction.includes('INSPECTOR')) {
    return 'INSPECTOR';
  }
  if (instruction.includes('THE ARCHIVIST') || instruction.includes('ARCHIVIST')) {
    return 'ARCHIVIST';
  }
  if (instruction.includes('THE EDITOR')) {
    return 'EDITOR';
  }
  if (instruction.includes('THE SCRIBE') || instruction.includes('SCRIBE')) {
    return 'SCRIBE';
  }
  if (instruction.includes('THE ARCHITECT') || instruction.includes('ARCHITECT')) {
    return 'ARCHITECT';
  }
  if (instruction.includes('Director') || instruction.includes('DIRECTOR')) {
    return 'DIRECTOR';
  }
  return 'SCRIBE';
}
